export const AppRoutes = {
  home: "/",
  select_difficulty: "/select-difficulty",
  batch_select: "/batch-select",
  phone_number: "/phone-number",
  introduction_audio: "/introduction-audio",
  select_stage: "/select-stage",
  stage: "/stage",
  messages: "/messages",
  help: "/help",
  stages_complete: "/stages-complete",
  ratings: "/ratings",
};
